import { FC } from "react"
import classes from "./styles.module.scss"
import { Input, InputBase, Combobox, useCombobox } from "@mantine/core"
import ChevronDownIcon from "@/shared/assets/icons/chevron-small-down.svg?react"
import { classNames } from "@/shared/lib/helpers/classNames"
import { UseFormReturnType } from "@mantine/form"
import { FilterFormValues } from "../../lib"

interface FilterDropdownProps {
	name: string
	label?: string
	options: { label: string; value: string }[]
	form: UseFormReturnType<FilterFormValues>
}

export const FilterDropdown: FC<FilterDropdownProps> = ({ name, label, options, form }) => {
	const combobox = useCombobox()

	const optionsList = options.map(item => (
		<Combobox.Option value={item.value} key={item.value}>
			{item.label}
		</Combobox.Option>
	))

	const handleOptionSubmit = (val: string) => {
		form.setFieldValue(name, val)
		combobox.closeDropdown()
	}

	const currentValue = (form.values[name] as string) || ""
	const selectedOption = options.find(item => item.value === currentValue)

	return (
		<Combobox
			store={combobox}
			transitionProps={{
				transition: "fade-up",
				duration: 100,
			}}
			onOptionSubmit={handleOptionSubmit}
		>
			<Combobox.Target>
				<InputBase
					component="button"
					type="button"
					pointer
					fw={400}
					fz={14}
					variant="filled"
					label={label}
					rightSection={
						<ChevronDownIcon
							className={classNames([classes.icon, combobox.dropdownOpened && classes.icon_opened])}
							width={20}
							height={20}
						/>
					}
					rightSectionPointerEvents="none"
					onClick={() => combobox.toggleDropdown()}
					classNames={{
						label: classes.label,
						input: classes.input,
						root: classes.root,
					}}
				>
					{selectedOption?.label || <Input.Placeholder>Не важно</Input.Placeholder>}
				</InputBase>
			</Combobox.Target>

			<Combobox.Dropdown className={classes.dropdown}>
				<Combobox.Options className={classes.options}>{optionsList}</Combobox.Options>
			</Combobox.Dropdown>
		</Combobox>
	)
}
